module.exports = __webpack_public_path__ + "static/media/2.89d5d455.png";